/* Auriani v7 chrome behaviour: announcement carousel, header (mega menu, search row, account popover,
   scroll shadow), trust slider, footer accordions, reveal on scroll, back-to-top, instant FAQ answers.
   No dependencies. Motion is skipped when the visitor prefers reduced motion. */
(() => {
  if (window.AurianiV7) return;
  window.AurianiV7 = true;
  document.documentElement.classList.add('au-js');

  /* ---------- delivery estimate (v7.1 P1): the one calculator, moved here from the PDP v7p code ----------
     Business days: production days, then transit days, counted from today, weekends skipped.
     The days come from the theme settings (au_make_days_*, au_ship_days_*) on each [data-au-eta-line]. */
  const addDays = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
  window.AurianiETA = {
    range(make, ship, from = new Date()) { return [addDays(from, make[0] + ship[0]), addDays(from, make[1] + ship[1])]; },
    format(d, style = 'short') { return d.toLocaleDateString('en-US', {month: style, day: 'numeric'}); }
  };
  const fillEta = () => document.querySelectorAll('[data-au-eta-line][data-make][data-ship]').forEach(node => {
    const make = node.dataset.make.split('-').map(Number), ship = node.dataset.ship.split('-').map(Number);
    if (make.length !== 2 || ship.length !== 2 || [...make, ...ship].some(Number.isNaN)) return;
    const [a, b] = window.AurianiETA.range(make, ship);
    const text = node.querySelector('[data-au-eta-text]') || node;
    text.textContent = `Order today · Estimated US delivery ${window.AurianiETA.format(a)} – ${window.AurianiETA.format(b)}`;
    node.hidden = false;
  });
  fillEta();
  document.addEventListener('auriani:cart-changed', () => setTimeout(fillEta, 0));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1200px)');
  const mobile = matchMedia('(max-width: 767px)');

  /* ---------- rotating strip (announcement + trust slider) ----------
     With reduced motion the messages still change, but without the slide. */
  function rotator(root, { track, slides, interval, drag, pauseBtn, activeWhen }) {
    if (!track || slides.length < 2) return;
    let index = 0, timer = 0, paused = false, hover = false;
    const go = (to, animate = true) => {
      index = (to + slides.length) % slides.length;
      track.style.transition = animate && !reduce.matches ? '' : 'none';
      track.style.transform = `translateX(${-100 * index}%)`;
      slides.forEach((s, i) => {
        const on = i === index;
        s.toggleAttribute('aria-hidden', !on);
        s.querySelectorAll('a').forEach(a => on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'));
      });
    };
    const stop = () => { clearInterval(timer); timer = 0; };
    const start = () => {
      stop();
      if (paused || hover || (activeWhen && !activeWhen.matches) || document.hidden) return;
      timer = setInterval(() => go(index + 1), interval);
    };
    root.addEventListener('mouseenter', () => { hover = true; stop(); });
    root.addEventListener('mouseleave', () => { hover = false; start(); });
    root.addEventListener('focusin', () => { hover = true; stop(); });
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) { hover = false; start(); } });
    document.addEventListener('visibilitychange', start);
    reduce.addEventListener?.('change', start);
    activeWhen?.addEventListener?.('change', () => { go(0, false); start(); });
    if (pauseBtn) pauseBtn.addEventListener('click', () => {
      paused = !paused;
      root.classList.toggle('is-paused', paused);
      pauseBtn.setAttribute('aria-pressed', String(paused));
      pauseBtn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      start();
    });
    if (drag) {
      let x0 = null, dx = 0, moved = false;
      drag.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        x0 = e.clientX; dx = 0; moved = false; stop();
        drag.classList.add('is-dragging');
      });
      addEventListener('pointermove', e => {
        if (x0 === null) return;
        dx = e.clientX - x0;
        if (Math.abs(dx) > 4) moved = true;
        track.style.transition = 'none';
        track.style.transform = `translateX(calc(${-100 * index}% + ${dx}px))`;
      }, { passive: true });
      const end = () => {
        if (x0 === null) return;
        drag.classList.remove('is-dragging');
        const w = drag.offsetWidth || 1;
        x0 = null;
        if (Math.abs(dx) > Math.min(60, w * .15)) go(index + (dx < 0 ? 1 : -1)); else go(index);
        start();
      };
      addEventListener('pointerup', end);
      addEventListener('pointercancel', end);
      drag.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    }
    go(0, false);
    start();
  }

  document.querySelectorAll('[data-au-announce]').forEach(root => {
    const viewport = root.querySelector('.au-announce__viewport');
    rotator(root, {
      track: root.querySelector('.au-announce__track'),
      slides: [...root.querySelectorAll('.au-announce__slide')],
      interval: Math.max(3000, +root.dataset.interval || 4000),
      drag: viewport,
      pauseBtn: root.querySelector('[data-au-announce-pause]')
    });
  });
  document.querySelectorAll('[data-au-trust]').forEach(root => {
    rotator(root, {
      track: root.querySelector('.au-trust__track'),
      slides: [...root.querySelectorAll('.au-trust__track > li')],
      interval: 3500,
      activeWhen: mobile
    });
  });

  /* ---------- header ---------- */
  const header = document.querySelector('[data-au-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 4);
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const items = [...header.querySelectorAll('[data-au-mega]')];
    let openTimer = 0, closeTimer = 0;
    const setOpen = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('.au-nav__toggle')?.setAttribute('aria-expanded', String(open));
    };
    const closeAll = except => items.forEach(i => { if (i !== except) setOpen(i, false); });
    items.forEach(item => {
      const toggle = item.querySelector('.au-nav__toggle');
      item.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'mouse' || !desktop.matches) return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        openTimer = setTimeout(() => { closeAll(item); setOpen(item, true); closeSearch(false); }, items.some(i => i.classList.contains('is-open')) ? 0 : 90);
      });
      item.addEventListener('pointerleave', e => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => { if (!item.contains(document.activeElement)) setOpen(item, false); }, 160);
      });
      toggle?.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        closeAll(item); setOpen(item, open);
        if (open) item.querySelector('.au-mega a')?.focus();
      });
      item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) setOpen(item, false); });
      item.addEventListener('keydown', e => {
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          e.stopPropagation(); setOpen(item, false); (toggle || item.querySelector('.au-nav__top')).focus();
        }
        if (e.key === 'ArrowDown' && e.target.classList.contains('au-nav__top') && toggle) {
          e.preventDefault(); closeAll(item); setOpen(item, true); item.querySelector('.au-mega a')?.focus();
        }
      });
    });
    desktop.addEventListener?.('change', () => closeAll());

    /* search row */
    const search = header.querySelector('#AuSearch');
    const searchBtn = header.querySelector('[data-au-search-toggle]');
    const input = search?.querySelector('input[type=search]');
    function openSearch() {
      if (!search) return;
      closeAll(); closeAcct();
      search.hidden = false;
      searchBtn?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => input?.focus());
    }
    function closeSearch(restore = true) {
      if (!search || search.hidden) return;
      search.hidden = true;
      searchBtn?.setAttribute('aria-expanded', 'false');
      if (restore) searchBtn?.focus();
    }
    searchBtn?.addEventListener('click', () => search.hidden ? openSearch() : closeSearch());
    search?.querySelector('[data-au-search-close]')?.addEventListener('click', () => closeSearch());
    search?.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !e.defaultPrevented && search.querySelector('[data-predictive-results]').hidden) closeSearch();
    });

    /* account popover */
    const acct = header.querySelector('[data-au-acct]');
    const acctBtn = acct?.querySelector('button');
    const acctPop = acct?.querySelector('.au-acct__pop');
    function closeAcct(restore) {
      if (!acctPop || acctPop.hidden) return;
      acctPop.hidden = true; acctBtn.setAttribute('aria-expanded', 'false');
      if (restore) acctBtn.focus();
    }
    acctBtn?.addEventListener('click', () => {
      const open = acctPop.hidden;
      closeAll(); closeSearch(false);
      acctPop.hidden = !open; acctBtn.setAttribute('aria-expanded', String(open));
      if (open) acctPop.querySelector('a')?.focus();
    });
    acct?.addEventListener('keydown', e => { if (e.key === 'Escape') closeAcct(true); });
    acct?.addEventListener('focusout', e => { if (!acct.contains(e.relatedTarget) && e.relatedTarget) closeAcct(false); });

    document.addEventListener('pointerdown', e => {
      if (!header.contains(e.target)) { closeAll(); closeAcct(false); }
      else if (acct && !acct.contains(e.target)) closeAcct(false);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  }

  /* bag count: keep the aria label and the empty style in step with cart.js updates */
  document.querySelectorAll('.au-count[data-cart-count]').forEach(node => {
    const sync = () => {
      const n = parseInt(node.textContent, 10) || 0;
      node.dataset.count = String(n);
      node.closest('a')?.setAttribute('aria-label', `Bag, ${n} ${n === 1 ? 'item' : 'items'}`);
    };
    new MutationObserver(sync).observe(node, { childList: true, characterData: true, subtree: true });
    sync();
  });

  /* ---------- footer accordions: open on desktop, closed on mobile ---------- */
  const fcols = [...document.querySelectorAll('[data-au-fcol]')];
  const setCols = () => fcols.forEach(d => { d.open = !mobile.matches; });
  setCols();
  mobile.addEventListener?.('change', setCols);
  fcols.forEach(d => d.querySelector('summary').addEventListener('click', e => { if (!mobile.matches) e.preventDefault(); }));

  /* ---------- reveal on scroll ---------- */
  const reveals = document.querySelectorAll('.au-reveal');
  if (reveals.length) {
    if (reduce.matches || !('IntersectionObserver' in window)) reveals.forEach(el => el.classList.add('is-in'));
    else {
      const io = new IntersectionObserver(entries => entries.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      }), { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(el => io.observe(el));
    }
  }

  /* ---------- back to top ---------- */
  const top = document.querySelector('[data-au-totop]');
  if (top) {
    const onScroll = () => top.classList.toggle('is-shown', scrollY > innerHeight * 1.5);
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    top.addEventListener('click', () => {
      scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
      (document.querySelector('.skip-link') || document.body).focus({ preventScroll: true });
    });
  }

  /* ---------- instant FAQ answers (only rendered when a page with handle "faq" exists) ---------- */
  const faq = document.querySelector('[data-au-faq]');
  if (faq) {
    const bar = faq.querySelector('.au-faq__bar');
    const panel = faq.querySelector('.au-faq__panel');
    const field = faq.querySelector('input');
    const list = faq.querySelector('[data-au-faq-results]');
    let entries = null;
    const load = async () => {
      if (entries) return entries;
      try {
        const html = await (await fetch(faq.dataset.url, { credentials: 'same-origin' })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const main = doc.querySelector('main') || doc.body;
        entries = [...main.querySelectorAll('details')].map(d => ({
          q: d.querySelector('summary')?.textContent.trim() || '',
          a: [...d.childNodes].filter(n => n.nodeName !== 'SUMMARY').map(n => n.textContent).join(' ').replace(/\s+/g, ' ').trim()
        }));
        if (!entries.length) entries = [...main.querySelectorAll('h3')].map(h => {
          let a = '', n = h.nextElementSibling;
          while (n && !/^H[1-3]$/.test(n.tagName)) { a += ' ' + n.textContent; n = n.nextElementSibling; }
          return { q: h.textContent.trim(), a: a.replace(/\s+/g, ' ').trim() };
        });
      } catch { entries = []; }
      return entries;
    };
    const render = async () => {
      const all = await load();
      const words = field.value.toLowerCase().split(/\s+/).filter(w => w.length > 2);
      const scored = all.map(e => ({ e, s: words.reduce((n, w) => n + (e.q.toLowerCase().includes(w) ? 3 : 0) + (e.a.toLowerCase().includes(w) ? 1 : 0), 0) }))
        .filter(x => !words.length || x.s > 0).sort((a, b) => b.s - a.s).slice(0, 4);
      list.replaceChildren(...scored.map(({ e }) => {
        const li = document.createElement('li');
        const strong = document.createElement('strong'); strong.textContent = e.q;
        const p = document.createElement('p'); p.textContent = e.a.length > 220 ? e.a.slice(0, 217) + '…' : e.a;
        li.append(strong, p); return li;
      }));
      if (!scored.length) { const li = document.createElement('li'); li.textContent = 'No match yet. Try other words, or see all questions.'; list.append(li); }
    };
    let t = 0;
    field.addEventListener('input', () => { clearTimeout(t); t = setTimeout(render, 160); });
    bar.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open; bar.setAttribute('aria-expanded', String(open));
      if (open) { field.focus(); render(); }
    });
    faq.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; bar.setAttribute('aria-expanded', 'false'); bar.focus(); } });
  }
})();